import { render, staticRenderFns } from "./SalidasCreate.vue?vue&type=template&id=5acdaf44&"
import script from "./SalidasCreate.vue?vue&type=script&lang=js&"
export * from "./SalidasCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports